import {
  IconAward,
  IconCircleCheck,
  IconCircleOff,
  IconCircleX,
  IconClipboardText,
  IconDownload,
  IconFilePlus,
  IconGitCompare,
  IconHeartHandshake,
  IconHistory,
  IconLock,
  IconNote,
  IconSend,
} from "@tabler/icons-react";
import type { RfqEventType, RfqHistoryEvent } from "@/lib/rfq/types";

import { RfqSection } from "./RfqSection";
import { useRfqLabels } from "@/lib/rfq/labels";

type IconComponent = (props: {
  size?: number | string;
  className?: string;
}) => any;

const EVENT_ICON: Record<RfqEventType, IconComponent> = {
  created: IconFilePlus,
  imported: IconDownload,
  issued: IconSend,
  recorded: IconClipboardText,
  locked: IconLock,
  compare: IconGitCompare,
  negotiate: IconHeartHandshake,
  award: IconAward,
  submit: IconCircleCheck,
  approve: IconCircleCheck,
  reject: IconCircleX,
  decline: IconCircleOff,
  note: IconNote,
};

const PRIMARY_EVENTS: RfqEventType[] = [
  "created",
  "issued",
  "locked",
  "compare",
  "award",
  "approve",
  "reject",
];

function RfqHistoryTab({ events }: { events: RfqHistoryEvent[] }) {
  const { t } = useRfqLabels();
  const ordered = [...events].reverse();

  if (ordered.length === 0) {
    return (
      <RfqSection
        icon={IconHistory}
        title={t("rfq.history.sectionTitle") || "歷程"}
      >
        <p className="py-10 text-center text-sm text-gray-500">
          {t("rfq.history.empty") || "尚無歷程紀錄。"}
        </p>
      </RfqSection>
    );
  }

  return (
    <RfqSection
      icon={IconHistory}
      title={t("rfq.history.sectionTitle") || "歷程"}
      bodyClassName="p-0"
    >
      <ol className="flex flex-col">
        {ordered.map((event, index) => {
          const Icon = EVENT_ICON[event.type];
          const primary = PRIMARY_EVENTS.indexOf(event.type) >= 0;
          const last = index === ordered.length - 1;
          return (
            <li key={event.id} className="relative flex gap-4 px-6 py-4">
              {!last ? (
                <span className="absolute bottom-0 left-[35px] top-12 w-px bg-gray-200" />
              ) : null}
              <span
                className={`z-10 flex h-9 w-9 shrink-0 items-center justify-center rounded-full border ${
                  primary
                    ? "border-blue-200 bg-blue-50 text-blue-600"
                    : "border-gray-200 bg-gray-50 text-gray-400"
                }`}
              >
                <Icon size={16} />
              </span>
              <div className="flex min-w-0 flex-1 flex-col gap-0.5 pt-1">
                <div className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-0.5">
                  <span className="text-sm font-semibold text-gray-700">
                    {event.title}
                  </span>
                  <time className="text-xs text-gray-400">{event.at}</time>
                </div>
                {event.detail ? (
                  <p className="text-sm leading-relaxed text-gray-500">
                    {event.detail}
                  </p>
                ) : null}
                <span className="mt-0.5 text-xs text-gray-400">
                  {t("rfq.history.actor") || "操作人"}：{event.actor}
                </span>
              </div>
            </li>
          );
        })}
      </ol>
    </RfqSection>
  );
}

export default RfqHistoryTab;
